export class Widgets {
    static config = {
      selector: 'errorWidget',
      controller: Widgets,
      bindings: {
        errorData:'<',
        widgetSize: '<',
      },
      template:`
        <mw-empty-state ng-if="$ctrl.errorData.message === 'No Documents found' && ($ctrl.widgetSize !== 'smallest' && $ctrl.widgetSize !== 'small')" icon="explore-empty-state" icon-size="large">
            <mw-empty-state-sub-text>No results found, adjust your search query or filters</mw-empty-state-sub-text>
        </mw-empty-state>
        <mw-empty-state ng-if="$ctrl.errorData.message === 'Data Failed' && ($ctrl.widgetSize !== 'smallest' && $ctrl.widgetSize !== 'small')" icon="explore-error-state" icon-size="large">
            <mw-empty-state-sub-text>Whoops, something went wrong behind the scenes, try reloading</mw-empty-state-sub-text>
        </mw-empty-state>
        <mw-empty-state ng-if="$ctrl.widgetSize === 'smallest' || $ctrl.widgetSize === 'small'">
          <mw-empty-state-sub-text ng-if="$ctrl.errorData.message === 'No Documents found'">No results found, try adjusting your search or date range {{$ctrl.errorData.id}}</mw-empty-state-sub-text>
          <mw-empty-state-sub-text ng-if="$ctrl.errorData.message === 'Data Failed'">Whoops, something went wrong behind the scenes, try reloading</mw-empty-state-sub-text>
        </mw-empty-state>
      `,
    }

    private errorData
    private widgetSize

    $onInit() {}

  }